import type { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'

import type { CheckDomainResponse } from '../providers/Entri'

export type UpdateProviderDetailsBody = Parameters<
  typeof DnsApiClient.updateEntriProviderDetails
>[1]

export const getUpdateEntriProviderDetailsBody = (
  data: NonNullable<CheckDomainResponse>,
): UpdateProviderDetailsBody => ({
  name: data.provider,
  mode: data.setupType.toUpperCase() as UpdateProviderDetailsBody['mode'],
})
